<div class="card-wrapper">
  <div class="card">
    <span class="h2">{{ label | translate }}</span>

    <ng-content></ng-content>
  </div>
</div>
